import { ModuleType, EntityType, ActionType } from "../../queryKeyFactory";

export const reconnectKeyFactory = {
  // Reconnection requests
  list: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "reconnectionRequests",
    "list",
    filters,
  ],
  details: (
    requestId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "details",
    requestId,
  ],
  create: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "reconnectionRequests",
    "create",
  ],
  update: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "update",
    requestId,
  ],
  delete: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "delete",
    requestId,
  ],

  // Summary and statistics
  summary: (params?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "reconnectionRequests",
    "summary",
    params,
  ],

  // Plans from onboarding API
  plans: (
    remoteUtilityId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "plans",
    remoteUtilityId,
  ],

  // Consumer operations
  consumerSearch: (
    filters?: any,
  ): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "reconnectionRequests",
    "consumerSearch",
    filters,
  ],
  consumerMetaData: (
    params?: any,
  ): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "reconnectionRequests",
    "consumerMetaData",
    params,
  ],
  updateConsumerPlan: (
    consumerId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "updateConsumerPlan",
    consumerId,
  ],
  reconnectActivateConsumer: (
    consumerId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "reconnectActivateConsumer",
    consumerId,
  ],

  // Status operations
  approve: (
    requestId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "approve",
    requestId,
  ],
  reject: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "reject",
    requestId,
  ],
  acknowledge: (
    requestId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "acknowledge",
    requestId,
  ],
  hold: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "hold",
    requestId,
  ],
  resolve: (
    requestId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "resolve",
    requestId,
  ],

  // Workflow operations
  workflow: (
    requestId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "workflow",
    requestId,
  ],
  completeWorkflow: (
    requestId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "completeWorkflow",
    requestId,
  ],

  // Meter data operations
  meterData: (
    requestId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "reconnectionRequests",
    "meterData",
    requestId,
  ],

  // Utility request configuration
  utilityConfig: (
    filters?: any,
  ): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "reconnectionRequests",
    "utilityConfig",
    filters,
  ],
  timeSlotChoices: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "reconnectionRequests",
    "timeSlotChoices",
  ],
  meterHistory: (
    consumerId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "reconnectionRequests",
    "meterHistory",
    consumerId,
  ],
  csvTemplate: (): [ModuleType, EntityType, "csvTemplate"] => [
    "cx",
    "reconnectionRequests",
    "csvTemplate",
  ],
  validateCsv: (): [ModuleType, EntityType, "validateCsv"] => [
    "cx",
    "reconnectionRequests",
    "validateCsv",
  ],
  searchConsumersInfo: (
    searchData: string,
    page: number,
    limit: number,
    category: string,
    subCategory: string,
    premise: string,
    status: string,
    accountType: string,
  ): [
    ModuleType,
    EntityType,
    "searchConsumersInfo",
    {
      searchData: string;
      page: number;
      limit: number;
      category: string;
      subCategory: string;
      premise: string;
      status: string;
      accountType: string;
    },
  ] => [
    "cx",
    "reconnectionRequests",
    "searchConsumersInfo",
    {
      searchData,
      page,
      limit,
      category,
      subCategory,
      premise,
      status,
      accountType,
    },
  ],
  bulkRequestConsumersPlanList: (
    batchId: string,
    page: number,
    limit: number,
  ): [
    ModuleType,
    EntityType,
    "bulkRequestConsumersPlanList",
    string,
    number,
    number,
  ] => [
    "cx",
    "reconnectionRequests",
    "bulkRequestConsumersPlanList",
    batchId,
    page,
    limit,
  ],
};
